<div class="site-header">
    <!-- <app-header-topbar></app-header-topbar> -->

    <div *ngIf="layout === 'classic'" class="site-header__middle container">
        <div class="site-header__logo">
            <a routerLink="/">
                <img src="assets/images/logo.png"> 
            </a>
        </div>
        <div class="site-header__search" >
            <app-search location="header"></app-search>
        </div>
        <div class="site-header__phone">
            <div class="row">
                <div class="site-header__phone-number" style="text-align: start; align-self: center;">
                    <div class="col-md-12" style="margin-bottom: 10px;">
                        <a style="color: black;" href="tel:{{ data.storephone[0] }}"> <i   class="fa fa-phone" aria-hidden="true"></i>&nbsp; {{ data.storephone[0] }}</a>
                        </div>
                    <div class="col-md-12" >
                        <a style="color: black;" href="mailto:{{ data.storeemail }}"> <i   class="fa fa-envelope" aria-hidden="true"></i>&nbsp; {{ data.storeemail }}</a>
                        </div>    
                    
                        
                </div>
               
                <app-indicator [link]="root.wishlist()" icon="heart-20" [counter]="wishlist.count$|async"></app-indicator>
                <app-indicator
                        link="./shop/cart"
                        icon="cart-20"
                        trigger="click"
                        [counter]="cart.quantity$|async"
                        (buttonClick)="onCartClick()"
                        #indicator="appIndicator"
                    >
                        <app-header-dropcart
                            *ngIf="dropcartType == 'dropdown'"
                            (closeMenu)="indicator.close(true)"
                        ></app-header-dropcart>
                    </app-indicator>
                    <app-indicator link="./account" icon="person-20" trigger="click" #indicator="appIndicator">
                        <app-account-menu (closeMenu)="indicator.close(true)"></app-account-menu>
                    </app-indicator>
                
            </div>
        </div>
    </div>

    <div class="site-header__nav-panel">
        <app-header-nav
            [departments]="layout === 'classic'"
            [logo]="layout === 'compact'"
            [search]="layout === 'compact'"
            stickyMode="pullToShow"
        ></app-header-nav>
    </div>
</div>
